import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { TmAccount } from '@/tscapi/model/account';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

interface PayloadType {
    creditcard: any;
    Id?: number;
}

// used to create/add a TSC credit card
// used in remove card modal on
export const useCreditCard = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const queryClient = useQueryClient();
    return {
        ...useMutation({
            mutationFn: async (payload: PayloadType) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }
                return http.post(`${base}${lang}/accounts/${userAccessTokenEdp}/creditcards`, payload.creditcard);
            },
            onSuccess: async (response, variables, context) => {
                // update detail view directly
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log('error');
            },
        }),
    };
};

// used to remove credit card
//
//
export const useRemoveCreditCard = () => {
    const queryClient = useQueryClient();
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    return {
        ...useMutation({
            mutationFn: (Id: number) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }
                return http.delete(`${base}${lang}/accounts/${userAccessTokenEdp}/creditcards/${Id}`);
            },
            onSuccess: (response, variables, context) => {
                // update detail view directly
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log(`${context} ${error}`);
            },
        }),
    };
};

// used to update credit card
//
//
export const useUpdateCreditCard = () => {
    const queryClient = useQueryClient();
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    return {
        ...useMutation({
            mutationFn: (payload: PayloadType) => {
                const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
                if (
                    !(
                        cookie.UserAccessToken != undefined &&
                        cookie.UserAccessToken.Token.length > 0 &&
                        cookie.UserAccessToken.Edp > 0
                    )
                ) {
                    throw new Error('UserToken expired');
                }
                return http.put(
                    `${base}${lang}/accounts/${userAccessTokenEdp}/creditcards/${payload.Id}`,
                    payload.creditcard,
                );
            },
            onSuccess: (response, variables, context) => {
                // update detail view directly
                queryClient.setQueryData(
                    ['account', cookie.UserAccessToken?.Edp, cookie.Language],
                    response.data as TmAccount,
                );
            },
            onError: (error, variables, context) => {
                console.log(`${context} ${error}`);
            },
        }),
    };
};
